import React, {Component} from "react";
import {connect} from 'react-redux';
import classNames from "classnames";
import FJToolbarCommon from "../view/FJToolbarCommon";
import FJColorContainer from "../view/FJColorContainer";
import FJLocalStore from "../../../store/FJLocalStore";
import InlineSVG from "react-inlinesvg";
import FJWriteIcon from "../../../icon/FJWriteIcon.svg";
import FJToolbarIconButton from "../view/FJToolbarIconButton";
import {FJDocumentColorAction, FJToolbarAction} from "../../../redux/action/FJRoot.action";
import FJFontFamilyContainer from "../view/FJFontFamilyContainer";
import FJToolbarDevider from "../view/FJToolbarDevider";
import FJFontBoldIcon from "../../../icon/FJFontBoldIcon.svg";
import FJFontItalicIcon from "../../../icon/FJFontItalicIcon.svg";
import {FJFontManager} from "fj-graph";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJOverLayPosition from "../view/FJPosition";

class FJToolbarOverLayTextContainer extends Component {

  render() {
    let {
      active,
      documentColors,
      disabled,
      openTextEditPanel,
      colors,
      fontFamily,
      disableBold,
      disableItalic,
      bold,
      italic,
      fontFamilyChanged,
      fontBold,
      fontItalic,
      addDocumentColor,
      deleteColor,
      textColorChanged,
      positionChange,
      supportPositions,
      position,
      loadingFonts,
    } = this.props;
    return (
      <FJToolbarCommon className={classNames('c-toolbar-text', {active})}>
        <FJFontFamilyContainer disabled={disabled}
                               loadingFonts={loadingFonts}
                               fontFamily={fontFamily}
                               fontFamilyList={FJFontManager.fontItems()}
                               fontFamilyChange={fontFamilyChanged}/>
        <FJToolbarDevider/>
        {
          colors.map((color, index) => {
            return (<FJColorContainer hasApplyToAll={false}
                                      useAnchorBody
                                      isTopLayer
                                      addDocumentColor={addDocumentColor}
                                      deleteColor={deleteColor}
                                      documentColors={documentColors}
                                      isSolid
                                      colorDataChange={textColorChanged}
                                      colorData={{mainColor: color}}
                                      tips={FJLocalStore._('text-color')}
                                      key={index}
            />);
          })
        }
        <FJToolbarDevider/>
        <FJToolbarIconButton tooltip={FJLocalStore._('bold')}
                             active={bold}
                             disabled={disableBold || disabled}
                             className='u-tooltip-bottom'
                             style={{float: 'left', marginRight: 6}}
                             onClick={fontBold}
                             icon={<InlineSVG src={FJFontBoldIcon} element='div'/>}/>
        <FJToolbarIconButton style={{marginRight: 0, float: 'left'}}
                             tooltip={FJLocalStore._('italic')}
                             active={italic}
                             disabled={disableItalic || disabled}
                             className='u-tooltip-bottom'
                             onClick={fontItalic}
                             icon={<InlineSVG src={FJFontItalicIcon} element='div'/>}/>
        <FJToolbarDevider/>
        <FJOverLayPosition disabled={disabled}
                           style={{float: 'left', marginRight: 6}}
                           positionChange={positionChange}
                           positionType={position}
                           supportPositions={supportPositions}
                           placement='bottomCenter'/>
        <FJToolbarIconButton style={{marginLeft: '6px'}} disabled={disabled} className='u-tooltip-bottom'
                             tooltip={FJLocalStore._('edit-text')} onClick={openTextEditPanel}
                             icon={<InlineSVG src={FJWriteIcon} element='div'/>}/>
      </FJToolbarCommon>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    loadingFonts: state.font.loadingFonts,
    documentColors: state.documentColor.documentColors,
    fontFamily: state.toolbar.fontFamily,
    disableBold: state.toolbar.disableBold,
    disableItalic: state.toolbar.disableItalic,
    colors: state.toolOverlay.colors,
    bold: state.toolOverlay.bold,
    italic: state.toolOverlay.italic,
    supportPositions: state.toolOverlay.supportPositions,
    position: state.toolOverlay.position,
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    openTextEditPanel: function () {
      dispatch(FJToolbarAction.showEditTextPanelAction());
    },
    fontBold: function () {
      FJCoreUtil.triggerBodyMousedown();
      dispatch(FJToolbarAction.setOverlayTextBoldAction());
    },
    fontItalic: function () {
      FJCoreUtil.triggerBodyMousedown();
      dispatch(FJToolbarAction.setOverlayTextItalicAction());
    },
    fontFamilyChanged: function (fontFamily) {
      dispatch(FJToolbarAction.setOverlayTextFontFamilyAction(fontFamily));
    },
    addDocumentColor: function (type, color) {
      dispatch(FJDocumentColorAction.addDocumentColorAction(type, color));
    },
    deleteColor: function (type, index) {
      dispatch(FJDocumentColorAction.deleteDocumentColorAction(type, index));
    },
    textColorChanged: function(type, colorData) {
      dispatch(FJToolbarAction.setOverlayTextColorAction(type, colorData));
    },
    positionChange: function (position) {
      dispatch(FJToolbarAction.setOverlayPositionAction(position))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarOverLayTextContainer);